<template>
  <div class="teaching-evaluate-apply-add">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDialog :visible.sync="visible"
                    width="420px"
                    title="添加方案"
                    custom-class="teaching-evaluate-apply-add-dialog"
                    @open="handleReset">
      <div class="add-main">
        <div class="main-cont"
             v-loading="committing"
             element-loading-text="数据提交中，请稍等...">
          <el-form size="mini"
                   label-position="top"
                   label-suffix="：">
            <el-form-item label="方案名称">
              <el-input v-model="form.name"
                        type="text"
                        maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="备注内容">
              <el-input v-model="form.remark"
                        type="textarea"
                        maxlength="200"
                        show-word-limit></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="footer">
          <el-button size="mini"
                     type="primary"
                     :disabled="committing"
                     @click="handleApply">提交保存</el-button>
          <el-button size="mini"
                     type="default"
                     @click="handleClose">取消操作</el-button>
        </div>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../../../../../elements/grid/DataGridDialog'
export default {
  name: 'TeachingEvaluateApplyAdd',
  components: {
    DataGridDialog
  },
  data () {
    return {
      visible: false,
      form: {
        name: '',
        remark: ''
      },
      committing: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    handleApply () {
      if (!this.form.name) {
        this.$message.warning('方案名称不能为空')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/teaching/evaluate/apply/plan/add',
        method: 'post',
        data: this.$qs.stringify(this.form)
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.handleClose()
              this.$nextTick(() => {
                let evaluation = response.data['evaluation']
                if (evaluation) {
                  this.$emit('add-success', evaluation)
                }
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.visible = false
    },
    handleReset () {
      Object.keys(this.form).forEach(key => {
        this.form[key] = ''
      })
    }
  }
}
</script>

<style lang="scss">
  .teaching-evaluate-apply-add {
    display: inline-block;
  }
  .teaching-evaluate-apply-add-dialog {
    .add-main {
      & > .main-cont {
        padding: 10px 15px;
        .el-form {
          .el-form-item {
            margin-bottom: 8px;
            .el-form-item__label {
              font-size: 12px;
              padding-bottom: 0;
            }
          }
        }
      }
      & > .footer {
        height: 52px;
        background-color: #fff;
        border-top: 1px solid rgba(0,0,0,.05);
        text-align: center;
        line-height: 50px;
      }
    }
  }
</style>
